/**
 * Single field row inside the EmployeeDialog form grid. Pure presentation —
 * takes any `children` (input, select, textarea) and wraps with overline label
 * + optional hint + optional required indicator.
 */
export const inputCls =
    "w-full border border-ink/15 bg-white py-2.5 px-3 text-sm focus:border-klein focus:outline-none text-ink";

export default function Field({ label, children, span = 3, testid, required, hint }) {
    return (
        <div className={`md:col-span-${span}`} data-testid={testid}>
            <label className="overline block mb-2">
                {label} {required && <span className="text-destructive">*</span>}
            </label>
            {children}
            {hint && <p className="text-[11px] text-ink/40 mt-1.5 leading-snug">{hint}</p>}
        </div>
    );
}
